var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82083 0.997304C1.92756 0.996942 2.03301 1.0205 2.12944 1.06624C2.22587 1.11198 2.31083 1.17875 2.37807 1.26164L5.82869 5.54812C5.93377 5.67596 5.99121 5.8363 5.99121 6.00178C5.99121 6.16725 5.93377 6.3276 5.82869 6.45543L2.25662 10.7419C2.13535 10.8878 1.9611 10.9796 1.77219 10.997C1.58328 11.0144 1.39519 10.9561 1.24929 10.8348C1.1034 10.7135 1.01165 10.5393 0.994234 10.3504C0.976817 10.1615 1.03516 9.97336 1.15642 9.82747L4.34985 5.9982L1.26358 2.16894C1.17622 2.06408 1.12073 1.93638 1.10367 1.80097C1.08661 1.66555 1.1087 1.52808 1.16732 1.40482C1.22594 1.28157 1.31864 1.17768 1.43446 1.10546C1.55027 1.03324 1.68435 0.99571 1.82083 0.997304Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallArrow);
export default __webpack_public_path__ + "static/media/SmallArrow.1e0ff6f0e504b6940c10b3e5c5d41151.svg";
export { ForwardRef as ReactComponent };